export default function () {

    return (x) => Math.sin(2 * Math.PI * x);
};
